// extracted by mini-css-extract-plugin
export default {"sectionTitle":"ShowOrderLines_sectionTitle__oF7R7","outsourcingPartnerHeader":"ShowOrderLines_outsourcingPartnerHeader__MmC52"};